// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import user from './user';

const commonReducer = combineReducers({
  user,
});

export default commonReducer;
